<!-- 预约首页 -->
<template>
  <div id="home">
    <div class="bodybox ninew">
      <div
        style="width: 100%; min-height: 200px; border-top: 1px solid #f3f3f3"
      >
        <van-swipe class="my-swipe" :autoplay="5000" indicator-color="white">
          <!-- <van-swipe-item>
            <van-image
              width="100%"
              fit="contain"
              v-if="shopInfos.image"
              :src="shopInfos.image.path"
            />
            <van-image
              v-else
              width="100%"
              height="200px"
              fit="cover"
              src="static/img/food1.jpg"
            />
          </van-swipe-item> -->
          <van-swipe-item v-for="image in images" :key="image">
            <van-image fit="contain" :src="image" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="shopInfo">
        <div>{{ $t("Home.shopName") }} {{ shopInfos.name }}</div>
        <div>{{ $t("Home.address") }} {{ shopInfos.address }}</div>
        <div>{{ $t("Home.intro") }} {{ shopInfos.intro }}</div>
        <div>{{ $t("Home.phone") }} {{ shopInfos.phone }}</div>
        <div>
          {{ $t("ShopInfo.time") }}：
          <template v-if="shopInfos.after_start"
            >{{ shopInfos.start_time }}-{{
              shopInfos.after_start
            }}&nbsp;&nbsp;{{ shopInfos.after_end }}-{{
              shopInfos.end_time
            }}</template
          ><template v-else
            >{{ shopInfos.start_time }}-{{ shopInfos.end_time }}</template
          >
        </div>
        <!-- <div>{{$t('Home.startTime')}} {{shopInfos.start_time}}</div>
            <div>{{$t('Home.endTime')}} {{shopInfos.end_time}}</div> -->
      </div>
      <div class="btnwrap">
        <van-button
          v-if="shopInfos.book == 1"
          style="
            width: 100%;
            height: 40px;
            margin-top: 15px;
            margin-bottom: 15px;
            line-height: 40px;
          "
          color="#2f75f4"
          round
          @click="$router.push('/InputInfo')"
          >{{ $t("Home.bookBtn") }}</van-button
        >
        <van-button
          v-if="shopInfos.takeaway == 1"
          style="
            width: 100%;
            height: 40px;
            margin-top: 15px;
            margin-bottom: 15px;
            line-height: 40px;
          "
          color="#2f75f4"
          round
          @click="getCode('TakeDishes')"
          >{{ $t("Home.takeawayBtn") }}</van-button
        >
        <van-button
          v-if="shopInfos.menu == 1"
          style="
            width: 100%;
            height: 40px;
            margin-top: 15px;
            margin-bottom: 15px;
            line-height: 40px;
          "
          color="#2f75f4"
          round
          @click="$router.push('/E_Dishes')"
          >{{ $t("Home.menuBtn") }}</van-button
        >
        <van-button
          v-if="shopInfos.is_pack == 1"
          style="
            width: 100%;
            height: 40px;
            margin-top: 15px;
            margin-bottom: 15px;
            line-height: 40px;
          "
          color="#2f75f4"
          round
          @click="getCode('PackDishes')"
          >{{ $t("Home.pickup") }}</van-button
        >
      </div>

      <van-grid
        :column-num="3"
        gutter="10"
        clickable
        style="padding-left: 0"
        v-if="shopInfos.associations && shopInfos.associations.length > 0"
      >
        <van-grid-item
          v-for="(shop, index) in shopInfos.associations"
          :key="index"
          :style="(index + 1) % 3 == 0 ? 'padding-right:0' : ''"
          @click="goShop(shop.link)"
        >
          <div class="shopBj">
            <van-image
              v-if="shop.image"
              class="shopIcon"
              round
              width="80"
              height="80"
              :src="shop.image"
            />
            <van-image
              v-else
              class="shopIcon"
              round
              width="80"
              height="80"
              src="./static/img/boss_shop_s.png"
            />
          </div>
          <div class="shopname1">
            <p class="shopname">{{ shop.name }}</p>
          </div>
        </van-grid-item>
      </van-grid>

      <div class="text">
        <p>
          {{ $t("Home.p") }}
          <button class="more" @click="$router.push('/ContactUs')">
            {{ $t("Home.more") }}
          </button>
        </p>
      </div>
      <div style="height: 80px"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      shopInfos: {},
      images: []
    };
  },
  mounted() {
    this.getShopInfo();
    sessionStorage.setItem("storeId", this.$route.params.id);
    sessionStorage.setItem("code", this.$route.params.code);
    this.getShopLang();
    console.log("创建的标识=" + localStorage.onlyCode);
    console.log("成功的标识=" + localStorage.successCode);
    console.log(localStorage.takeOrderId);
  },
  methods: {
    //获取店铺信息
    getShopInfo() {
      this.$axios({
        method: "get",
        headers: {
          code: this.$route.params.code
        },
        url:
          this.$build + "/api/store/" + this.$route.params.id + "/customerShow"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.shopInfos = res.data.data;
            this.images.push(res.data.data.image.path);
            res.data.data.banner.forEach(item => {
              this.images.push(item.path);
            });
            sessionStorage.setItem("images", res.data.data.image.path);
            sessionStorage.setItem("currency", res.data.data.currency.unit);
            sessionStorage.setItem("is_quick", res.data.data.is_quick);
            sessionStorage.setItem(
              "is_additional",
              res.data.data.is_additional
            );
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },

    //获取店铺语言
    getShopLang() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/store/" + this.$route.params.id + "/language"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            if (res.data.data.id == 2 || res.data.data.name_en == "zh_hk") {
              this.$i18n.locale = "hk";
            } else if (res.data.data.id == 1 || res.data.data.name_en == "en") {
              this.$i18n.locale = "en";
            } else if (
              res.data.data.id == 3 ||
              res.data.data.name_en == "zh_cn"
            ) {
              this.$i18n.locale = "zh";
            }
            sessionStorage.setItem("locale", this.$i18n.locale);
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 外卖-创建客户唯一标识
    // getCode(){
    //     this.$axios({
    //         method:'get',
    //         url:this.$build+'/api/shopcart/create',
    //     }).then(res=>{
    //         console.log(res)
    //         if(res.data.status==200){
    //             localStorage.setItem('onlyCode',res.data.code)
    //             var vm = this;
    //             // 跳转到菜品页面
    //             setTimeout(()=>{
    //                 vm.$router.push('/OrderStatus')
    //             },500)
    //         }else{
    //             for (var item in res.data.error) {
    //                 this.$toast({
    //                     type:'fail',
    //                     message:res.data.error[item],
    //                 });
    //             }
    //         }
    //     }).catch(err => {
    //         this.$toast({
    //             type:'fail',
    //             message:this.$t('common.message'),
    //         });
    //     });
    // },
    getCode(status) {
      this.getNewCode(status);
      // if(localStorage.hasOrder == 1){
      //     this.getNewCode();
      // }else{
      //     this.$router.push('/OrderStatus');
      // }
    },
    getNewCode(status) {
      this.$axios({
        method: "get",
        url: this.$build + "/api/shopcart/create"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            localStorage.removeItem("takeOrderNo");
            localStorage.removeItem("successCode");
            // localStorage.removeItem('hasOrder');
            localStorage.setItem("onlyCode", res.data.code);
            var vm = this;
            // 跳转到菜品页面
            setTimeout(() => {
              if (status == "TakeDishes") {
                vm.$router.push("/TakeDishes");
              } else if (status == "PackDishes") {
                vm.$router.push("/PackDishes");
              }
            }, 500);
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    goShop(link) {
      window.open(link);
    }
  }
};
</script>
<style scoped>
#home {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background-color: #f3f3f3;
}
.bodybox {
  max-width: 800px !important;
  margin: 0 auto;
  min-width: 375px !important;
}
.ninew {
  width: 95%;
  margin: 0 auto;
}
.btnwrap {
  margin: 40px 0;
}
#app {
  min-height: 100vh;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #ffb20d;
}
.van-button__text {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
}
.text {
  text-align: center;
}
.copyright {
  color: gray;
  margin-top: 30px;
  margin-bottom: 10px;
}
.title {
  color: #ffb20d;
  font-weight: bold;
  padding: 10px;
}
p {
  margin: 0;
  padding: 0;
  color: #707070;
  font-weight: bold;
  padding: 10px 10px;
  line-height: 1.3rem;
  font-size: 15px;
}
.more {
  background: #1e90ff;
  color: #fff;
  height: 40px;
  outline: none;
  border: none;
  border-radius: 30px;
  font-weight: normal;
}
.shopInfo div {
  margin-top: 10px;
}

/deep/ .van-grid-item__content p {
  font-size: 12px;
  text-align: center;
  margin: 0;
  padding: 0;
}
/deep/ .van-grid-item__content {
  padding: 0;
  border-radius: 5px;
  padding-bottom: 10px;
  align-items: center;
  -webkit-align-items: center;
  justify-content: flex-start;
}
.my-swipe .van-image {
  width: 100%;
  height: 23.4375rem;
}
.van-grid-item__content p.shopname {
  font-size: 15px;
}
.shopname1 {
  height: 36px;
  align-items: center;
  display: inline-flex;
}
.shopname {
  line-height: 18px;
  align-items: center;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.shoptime {
  font-size: 12px;
  color: #d4d4d4;
}
.shoptime span {
  color: rgb(253, 63, 63);
}
.van-image {
  align-items: center;
  -webkit-align-items: center;
}
.van-image__img {
  vertical-align: middle;
}
.shopBj {
  width: 100%;
  border-radius: 5px 5px 0 0;
  text-align: center;
}
.shopIcon {
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/reserve/Home.vue